var path = '/app/components/footer/footer.html';
var html = "<div class=\"container\">\n  <p class=\"text-muted\">v{{ ctrl.version }} | &copy; QTH54 Inc. All Rights Reserved</p>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;